import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import React from 'react';

const RoleIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 24 24"
      >
        <g id="Symbols">
          <g id="Icon-_x2F_-Perm-Identity" transform="translate(-4.000000, -4.000000)">
            <path
              id="Shape"
              d="M16,9.9c1.2,0,2.1,0.9,2.1,2.1s-0.9,2.1-2.1,2.1s-2.1-0.9-2.1-2.1S14.8,9.9,16,9.9L16,9.9z
			 M16,18.9c3,0,6.1,1.5,6.1,2.1v1.1H9.9V21C9.9,20.4,13,18.9,16,18.9L16,18.9z M16,8c-2.2,0-4,1.8-4,4s1.8,4,4,4s4-1.8,4-4
			S18.2,8,16,8z M16,17c-2.7,0-8,1.3-8,4v3h16v-3C24,18.3,18.7,17,16,17z"
            />
          </g>
        </g>
      </svg>
    </SvgIcon>
  );
};

export default RoleIcon;
